// import IconInsurance from '@/shared/assets/icons/icon-insurance.svg?react';
import IconLogout from '@/shared/assets/icons/icon-logout.svg?react';
import Logo from '@/shared/assets/icons/logo-small.svg?react';

import { getAppsRoute, getRouteLogout } from '@/shared/const/router.const';
import { usePermissions } from '@/shared/hooks/usePermissions/usePermissions';
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarGroup,
  SidebarGroupContent,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from '@/shared/ui/shadcn/ui/sidebar';
import { sidebarNavItems } from '@/widgets/app-sidebar/model/nav.const.ts';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router';

export function AppSidebar() {
  const routerLocation = useLocation();
  const { pathname } = routerLocation;

  const { t } = useTranslation('nav');
  const { can } = usePermissions();

  const isBeta =
    location.hostname.includes('front') ||
    process.env.NODE_ENV === 'development';

  return (
    <Sidebar collapsible="icon" innerClassName="p-4 mb-4">
      <SidebarHeader className="p-4">
        <Link to={getAppsRoute()}>
          <Logo />
        </Link>
      </SidebarHeader>
      <SidebarContent>
        <SidebarGroup className="p-0">
          <SidebarGroupContent>
            <SidebarMenu>
              {sidebarNavItems
                .filter((item) => can(item.permission))
                .filter((item) => (isBeta ? true : item.isReleased))
                .map((item) => {
                  const isActive = pathname.includes(item.url);
                  return (
                    <SidebarMenuItem key={item.title}>
                      <SidebarMenuButton
                        asChild
                        className="rounded-xs transition-colors hover:bg-gray-600/40"
                        size="lg"
                        isActive={isActive}
                      >
                        <Link to={item.url}>
                          <item.icon />
                          <span>{t(item.title)}</span>
                        </Link>
                      </SidebarMenuButton>
                    </SidebarMenuItem>
                  );
                })}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
      <SidebarFooter className="p-0">
        <SidebarMenuButton
          asChild
          className="hover:bg-red-fee4e2 hover:text-text-error rounded-xs bg-white/10 transition-colors"
          size="lg"
        >
          <Link to={getRouteLogout()}>
            <IconLogout />
            <span>{t('Выйти из аккаунта')}</span>
          </Link>
        </SidebarMenuButton>
      </SidebarFooter>
    </Sidebar>
  );
}
